var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',{staticClass:"info-table-image",attrs:{"preview-src-list":_vm.srcList,"src":_vm.getSrc(_vm.urlFile, _vm.diskName),"alt":"Sin Imagen"},on:{"click":function($event){_vm.zoom(_vm.getSrc(_vm.urlFile, _vm.diskName))}}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"})])
}
var staticRenderFns = []

export { render, staticRenderFns }